import { useSelector } from 'react-redux';
import { RootState } from 'state/store';

import { isCountBasedGuarantorHidden } from 'utils/display-logic/hiddenGuarantorResponses';

import { useEvaluateDisplayCondition } from './useEvaluateDisplayCondition';

export const useIsCountBasedGuarantorHidden = (pageId?: string): boolean => {
  const form = useSelector((state: RootState) => state.application.form);
  const evaluateDisplayCondition = useEvaluateDisplayCondition();

  if (!pageId) return false;

  return isCountBasedGuarantorHidden({
    form,
    pageId,
    evaluateDisplayCondition,
  });
};
